<template>
    <div>
        <BlockUI v-show="mode==='loading'" :message="loadingMessage" url="/images/loading-spinner.gif"></BlockUI>

        <div v-show="mode==='scanning' || mode==='searching'">
            <div class="alert alert-success" role="alert" v-show="successText">{{ successText }}</div>

            <div id="scanner" v-show="mode==='scanning'">
                <div class="form-group form-group-lg">
                    <div class="row">
                        <div class="col-xs-8 col-sm-9 col-md-10">
                            <input type="text" class="form-control" id="ticketCode" placeholder="Vpiši kodo vstopnice" v-model="ticketCode">
                        </div>
                        <div class="col-xs-4 col-sm-3 col-md-2">
                            <button type="button" class="btn btn-default" @click="checkTicket()">Išči</button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-warning" role="alert" v-show="errorScanningText">{{ errorScanningText }}</div>
                <qrcode-reader :paused="mode!=='scanning'" @decode="onDecode" @init="onInit"></qrcode-reader>
            </div>

            <div id="searchByName" v-show="mode==='searching'">
                <div class="form-group form-group-lg">
                    <div class="row">
                        <div class="col-xs-8 col-sm-9 col-md-10">
                            <input type="text" class="form-control" id="ownerName" placeholder="Vpiši ime" v-model="ownerName">
                        </div>
                        <div class="col-xs-4 col-sm-3 col-md-2">
                            <button type="button" class="btn btn-default" @click="findByName">Išči</button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-warning" role="alert" v-show="errorSearchingText">{{ errorSearchingText }}</div>
            </div>
        </div>

        <div id="ticketInfo" v-show="mode==='info'">
            <div class="alert alert-warning" role="alert" v-show="errorInfoText">{{ errorInfoText }}</div>
            <div class="row">
                <div class="col-xs-8 col-sm-9 col-md-10">
                    <h3>Podatki o vstopnici</h3>
                    <ul>
                        <li>Dogodek: <b>{{ ticket.event_name }}</b></li>
                        <li>Koda vstopnice: <b>{{ ticket.uid }}</b></li>
                        <li>Ime in Priimek: <b>{{ ticket.owner }}</b></li>
                        <li>Status: <b>{{ ticket.status === 'created' ? 'valid' : ticket.status }}</b></li>
                        <li>Datum: <b>{{ ticket.data.event_date | formatDateTime }}</b></li>
                        <li>Lokacija: <b>{{ ticket.data.event_location }}</b></li>
                    </ul>
                </div>
                <div class="col-xs-4 col-sm-3 col-md-2" v-show="ticket.status !== 'cancelled'">
                    <button type="button" class="btn btn-success" @click="useTicket">Check In</button>
                </div>
            </div>
            <h3>Zgodovina vstopnice</h3>
            <table class="table table-condensed">
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Oseba</th>
                    <th>Dejanje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="historyRecord in ticket.history">
                    <td>{{ historyRecord.created_at | formatDateTime }}</td>
                    <td>{{ historyRecord.username }}</td>
                    <td>{{ historyRecord.action === 'used' ? 'Check-In' : historyRecord.action }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div id="foundTickets" v-show="mode==='list'">
            <div class="alert alert-warning" role="alert" v-show="errorListText">{{ errorListText }}</div>
            <h3>TICKETS FOUND</h3>
            <table class="table">
                <thead>
                <tr>
                    <th>Oseba</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Event</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ticket in tickets" @click="onDecode(ticket.hashId)">
                    <td>{{ ticket.owner }}</td>
                    <td>{{ ticket.status === 'created' ? 'valid' : ticket.status }}</td>
                    <td>{{ ticket.data.event_date | formatDateTime }}</td>
                    <td>{{ ticket.data.event_name }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <nav class="navbar navbar-default navbar-fixed-bottom">
            <div class="container-fluid">
                <div class="btn-group btn-group-justified" role="group" aria-label="Mode selector">
                    <a href="#" class="btn btn-default" :class="{'active': mode === 'scanning'}" role="button" @click="successText = ''; mode = 'scanning'">
                        <i class="fa fa-lg fa-qrcode" aria-hidden="true"></i>
                        <p>Išči po vstopnici</p>
                    </a>
                    <a href="#" class="btn btn-default" :class="{'active': mode === 'searching'}" role="button" @click="successText = ''; mode = 'searching'">
                        <i class="fa fa-lg fa-keyboard-o" aria-hidden="true"></i>
                        <p>Išči po imenu</p>
                    </a>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import BlockUI from 'vue-blockui'
    Vue.use(BlockUI);

    import VueQrcodeReader from 'vue-qrcode-reader'
    Vue.use(VueQrcodeReader);

    export default {
        name: "ticket-check",

        data: function () {
            return {
                ticketCode: '',
                ownerName: '',
                mode: 'scanning', // scanning|searching|loading|info|list
                loadingMessage: '',
                errorScanningText: '',
                errorSearchingText: '',
                errorInfoText: '',
                errorListText: '',
                successText: '',
                ticket: {
                    owner: '',
                    status: '',
                    data: {
                        event_name: '',
                        event_date: '',
                        event_location: '',
                        description: ''
                    },
                    history: []
                },
                tickets: [], // for tickets found by name
            }
        },

        filters: {
            formatDateTime(value) {
                let moment = require('moment');
//                console.log(value);
                return moment(value, 'YYYY-MM-DD HH:mm').format('DD.MM.YY ob HH:mm');
            }
        },

        mounted() {
            // will use class "non-touch" to fix sticky hover effect on mobile devices
            const touchSupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
            if (!touchSupport){ // browser doesn't support touch
                document.documentElement.className += " non-touch";
            }
        },

        methods: {
            async onInit (promise) {
                this.loadingMessage = 'Initializing...';
                this.mode = 'loading';

                try {
                    await promise

                    // successfully initialized
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.errorScanningText = 'User denied camera access permisson';
                    } else if (error.name === 'NotFoundError') {
                        this.errorScanningText = 'No suitable camera device installed';
                    } else if (error.name === 'NotSupportedError') {
                        this.errorScanningText = 'Page is not served over HTTPS (or localhost)';
                    } else if (error.name === 'NotReadableError') {
                        this.errorScanningText = 'Maybe camera is already in use';
                    } else if (error.name === 'OverconstrainedError') {
                        this.errorScanningText = 'Passed constraints don\'t match any camera. Did you requested the front camera although there is none?';
                    } else {
                        this.errorScanningText = 'Browser is probably lacking features (WebRTC, Canvas)';
                    }
                } finally {
                    this.mode = 'scanning';
                }
            },

            onDecode(content) {
                this.ticketCode = content;
                this.checkTicket();
            },

            checkTicket() {
                this.ticketCode = this.ticketCode.toUpperCase();
                this.errorInfoText = '';
                this.errorScanningText = '';
                this.loadingMessage = 'Iščem vstopnico...';
                this.mode = 'loading';
                axios.get('/admin/tickets/api/' + this.ticketCode.toUpperCase())
                    .then(response => {
//                        console.log(response);
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success === true) {
                                this.mode = 'info';
                                this.ticket = response.data.ticket;
                            } else {
                                this.ticketCode = '';
                                this.errorScanningText = 'Vstopnica ni bila najdena. Poizkusite znova, ali pa iščite po imenu.';
                                this.mode = 'scanning';
                            }
                        } else {
                            this.ticketCode = '';
                            this.errorScanningText = 'Something wrong happened';
                            this.mode = 'scanning';
                        }
                    }, response => {
                        // error callback
//                        console.log(response);
                        this.ticketCode = '';
                        this.errorScanningText = 'Something wrong happened';
                        this.mode = 'scanning';
                    });
            },

            useTicket() {
                this.errorInfoText = '';
                this.loadingMessage = 'Potrjujem vstop...';
                this.mode = 'loading';
                axios.put('/admin/tickets/api/' + this.ticketCode + '/confirm')
                    .then(response => {
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success === true) {
                                this.ticketCode = '';
                                this.ownerName = '';
                                this.mode = 'scanning';
                                this.successText = 'Vstopnica je bila potrjena';
                                setTimeout(() => {this.successText = ''}, 5000);
                            } else {
                                this.errorInfoText = 'Something wrong happened';
                                this.mode = 'info';
                            }
                        } else {
                            this.errorInfoText = 'Something wrong happened';
                            this.mode = 'info';
                        }
                    }, response => {
                        // error callback
//                        console.log(response);
                        this.errorInfoText = 'Something wrong happened';
                        this.mode = 'info';
                    });
            },

            findByName() {
                this.errorSearchingText = '';
                this.loadingMessage = 'Iščem vstopnico...';
                this.mode = 'loading';
                axios.get('/admin/tickets/api/get-by-name/' + this.ownerName)
                    .then(response => {
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success === true) {
                                this.mode = 'list';
                                this.tickets = response.data.tickets;
                            } else {
                                this.ownerName = '';
                                this.errorSearchingText = 'Vstopnica ni bila najdena. Poizkusite znova, ali pa iščite po kodi vstopnice.';
                                this.mode = 'searching';
                            }
                        } else {
                            this.ownerName = '';
                            this.errorSearchingText = 'Something wrong happened';
                            this.mode = 'searching';
                        }
                    }, response => {
                        // error callback
//                        console.log(response);
                        this.ownerName = '';
                        this.errorSearchingText = 'Something wrong happened';
                        this.mode = 'searching';
                    });
            },
        }
    }
</script>

<style scoped>
    .btn {
        padding-left: 30px;
        padding-right: 30px;
    }

    html:not(.non-touch) .navbar .btn:hover {
        background: transparent !important;
    }

    html:not(.non-touch) .navbar .btn.active,
    .navbar .btn.active {
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffe5b0+0,ffc272+100 */
        background: #ffe5b0 !important;
        /* Old browsers */
        background: -moz-linear-gradient(left, #ffe5b0 0%, #ffc272 100%) !important;
        /* FF3.6-15 */
        background: -webkit-linear-gradient(left, #ffe5b0 0%, #ffc272 100%) !important;
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right, #ffe5b0 0%, #ffc272 100%) !important;
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffe5b0', endColorstr='#ffc272', GradientType=1) !important;
        /* IE6-9 */
        border-color: #ffcc84;
        box-shadow: none !important;
    }

    .navbar .btn:last-child {
        border-left-width: 0;
    }

    .navbar .btn p {
        margin-bottom: 0;
    }

    .navbar-fixed-bottom {
        padding: 5px 0;
    }

    #foundTickets tr {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TicketCheck.vue